import { useStyletron } from 'baseui'
import { useTranslation } from 'react-i18next'

interface StatusColour {
  light: string
  dark: string
}

function getStatusColour(status: string): StatusColour {
  switch (status) {
    case 'Données client à renseigner':
    case 'Souscription web a finaliser':
    case 'Données compteur a renseigner':
      return { light: '#ffed78', dark: '#8b7900' }
    case 'BS complet':
    case 'Prêt pour la transmission':
      return { light: '#C6EE55', dark: '#5B6E27' }
    case 'Erreur lors du transfert':
    case 'Signé avec erreur':
      return { light: '#ffd07a', dark: '#40281f' }
    case 'Rétractation par le fournisseur':
    case 'Rétractation par Selectra':
      return { light: '#FEE9E9', dark: '#DC0909' }
    case 'Signé':
    case 'Activé':
      return { light: '#F1FFFF', dark: '#0C8A1E' }
    case 'Transféré':
      return { light: '#00bbbb', dark: '#003434' }
    default:
      return { light: '#c1d1e2', dark: '#565e66' }
  }
}

interface StatusCellProps {
  status: string
}

const StatusCell = ({ status }: StatusCellProps) => {
  const [css] = useStyletron()
  const colour = getStatusColour(status)
  const { t } = useTranslation()

  const badgeStyle = css({
    display: 'flex',
    width: '100%',
    padding: '.125rem .25rem',
    border: `2px solid ${colour.light}`,
    background: colour.light,
    color: colour.dark,
    borderRadius: '.25rem',
  })
  const textStyle = css({
    margin: '0 auto',
    fontSize: '.75rem',
    textAlign: 'center',
  })

  return (
    <div className={badgeStyle}>
      <div className={textStyle}>{status || t('contractsTable:no_status')}</div>
    </div>
  )
}

export default StatusCell
